import { motion } from "framer-motion";
import { TrendingUp, Users, Flame, Award, Share2, Bell, Bookmark, Trophy } from "lucide-react";

const viralFeatures = [
  { icon: TrendingUp, title: "Trending Topics", desc: "Real-time trending hashtags and content" },
  { icon: Users, title: "Viral Referrals", desc: "Earn rewards by inviting friends" },
  { icon: Flame, title: "Daily Streaks", desc: "Login daily for bonus rewards" },
  { icon: Award, title: "Creator Badges", desc: "Verified & achievement badges" },
  { icon: Share2, title: "Cross-Platform Share", desc: "Share to any social platform" },
  { icon: Bell, title: "Smart Notifications", desc: "AI-powered notification system" },
  { icon: Bookmark, title: "Collections", desc: "Save & organize your favorites" },
  { icon: Trophy, title: "Leaderboards", desc: "Compete for top creator spots" },
];

const ViralSection = () => {
  return (
    <section className="py-4 md:py-24 bg-muted/30">
      <div className="container px-4">
        <motion.div
          className="text-center mb-4 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-sm font-medium text-accent uppercase tracking-wider">Go Viral</span>
          <h2 className="font-display text-2xl md:text-5xl font-bold mt-2 md:mt-3 mb-2 md:mb-4">
            Built for <span className="gradient-text">Virality</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-sm md:text-base">50+ viral mechanics designed to grow your audience exponentially.</p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {viralFeatures.map((f, i) => (
            <motion.div
              key={f.title}
              className="flex items-start gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-card shadow-card hover:shadow-card-hover transition-all"
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.04 }}
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-accent/10 flex items-center justify-center shrink-0 text-accent">
                <f.icon className="w-5 h-5" />
              </div>
              <div>
                <h3 className="font-display font-semibold text-sm">{f.title}</h3>
                <p className="text-muted-foreground text-xs mt-0.5">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ViralSection;
